import { createFileRoute } from '@tanstack/react-router'

import { PlayerRelationshipRouteKernel } from '~/features/player-relationships/route-kernel'
import { playerRelationshipRouteOptions } from '~/features/player-relationships/route-options'

export const Route = createFileRoute('/research/players/$playerId')({
  ...playerRelationshipRouteOptions,
  component: PlayerRelationshipRoute,
})

function PlayerRelationshipRoute() {
  return <PlayerRelationshipRouteKernel route={Route} />
}
